import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../hybrid/wrappers';
import ReactDOM from 'react-dom';
import ModalDropDown from './ModalDropDown/ModalDropDown';
import css from './TableDropdown.module.scss';
import classnames from 'classnames';
import { checkBrowser } from '../../../../common/utils/utils';

const TableDropdown = ({ val, alias, activeTr, setActiveTr, refTable, gridName, refTableChild }) => {
    const modalDropdown = useRef(null);
    const modal = useRef(null);
    const showDropdown = useMemo(() => alias === activeTr, [alias, activeTr]);
    const dataArr = Object.keys(val).filter((k) => val[k]);
    const firstVal = dataArr.shift();

    const isDropdown = useMemo(() => {
        const res = [];
        dataArr.map((item) => {
            if (val[item] !== null) {
                res.push(val[item]);
            }
        });
        return res.length > 0;
    }, [dataArr, val]);

    const ContactImg = (val) => {
        switch (val) {
            case 'phone':
                return 'phone-colored';
            case 'facebook':
                return 'facebook-colored';
            case 'instagram':
                return 'instagram-colored';
            case 'ok':
                return 'odnoklassniki-colored';
            case 'telegram':
                return 'telegram-colored';
            case 'twitter':
                return 'twitter-colored';
            case 'viber':
                return 'viber-colored';
            case 'vk':
                return 'vkontakte-colored';
            case 'whatsapp':
                return 'whatsapp-colored';
            case 'email':
                return 'email-colored';
            default:
                return 'phone';
        }
    };

    return (
        <div className={css.dropdownWrapper} ref={modalDropdown}>
            <div
                key={alias}
                className={
                    showDropdown && !!isDropdown
                        ? classnames(css.dropdownBlockRow, css.dropdownBlockRowActiveWeb)
                        : css.dropdownBlockRow
                }
                onClick={(e) => {
                    e.stopPropagation();
                    setActiveTr(alias !== activeTr ? alias : false);

                    if (modal?.current) {
                        // TODO ZOOM

                        const getModalDropdown = modalDropdown?.current?.getBoundingClientRect();
                        const getRefTable = refTable?.current.getBoundingClientRect();
                        modal.current.style.top = `${checkBrowser(
                            getModalDropdown?.top - getRefTable?.top + getModalDropdown?.height
                        )}px`;
                        modal.current.style.left = `${checkBrowser(getModalDropdown?.left - getRefTable?.left)}px`;
                        modal.current.style.minWidth = `${checkBrowser(getModalDropdown?.width)}px`;

                        // TODO ZOOM
                    }
                }}
            >
                {svgSprite('phone-colored', { className: css.contactIcon })}
                <p className={css.dropdownItem}>{`${val[firstVal]}`}</p>
                {!!isDropdown && (
                    <p className={classnames(css.dropdownArrow, css.cursorPointer)}>
                        {showDropdown
                            ? svgSprite('angle-up', {
                                  className: css.dropdownArrowSvg
                              })
                            : svgSprite('angle-down', {
                                  className: css.dropdownArrowSvg
                              })}
                    </p>
                )}
            </div>
            {!!isDropdown &&
                document.getElementById(`${gridName}portalDropdown`) &&
                ReactDOM.createPortal(
                    <ModalDropDown
                        showDropdown={showDropdown}
                        dataArr={dataArr}
                        modal={modal}
                        ContactImg={ContactImg}
                        refTable={refTable}
                        modalDropdown={modalDropdown}
                        refTableChild={refTableChild}
                    >
                        {val}
                    </ModalDropDown>,
                    document?.getElementById(`${gridName}portalDropdown`)
                )}
        </div>
    );
};

TableDropdown.propTypes = {
    alias: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeTr: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    setActiveTr: PropTypes.func,
    refTable: PropTypes.object,
    gridName: PropTypes.string,
    refTableChild: PropTypes.object
};

export default TableDropdown;
